import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "app/services/auth.service";
import { CookieService } from "ngx-cookie";
import { Observable, Subject } from "rxjs";
import { Storage } from "../storage/storage";
import { of } from "rxjs/observable/of";

@Injectable()
export class AuthOracleTokenGuard implements CanActivate {
  token: any;
  hook_url: any;
  logged: any;

  constructor(
    private authService: AuthService,
    private storage: Storage,
    private _cookieService: CookieService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.token = next.queryParams.token;
    this.hook_url = next.queryParams.HOOK_URL;
    console.log("next.queryParams", next.queryParams);
    console.log("---> next.queryParams.HOOK_URL", next.queryParams.HOOK_URL);
    console.log("---> next.queryParams.HOOK_URL", next.queryParams.buyerCookie);
    this.storage.buyerCookie = next.queryParams.buyerCookie;
    if (this._cookieService.get("NendiToken") && !this.token) {
      return true
      // return this.authService.isOracleJwtValid(
      //   this._cookieService.get("NendiToken"),
      //   this.hook_url
      // );
    } else {
      this._cookieService.put("NendiToken", this.token);
      if (this.storage.hook_url === undefined || !this.storage.hook_url) {
        this.storage.hook_url = this.hook_url.replace(/&amp;/g, "&");
      }
      return of(true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/guards-oracle/auth-oracle-token.guard.ts